import {
  Contact,
  Editing,
  Home,
  Interpreting,
  Portfolio,
  Subtitling,
  Transcription,
  Translation,
} from './pages'

export const homeRoute = {
  path: '/',
  title: 'About me',
  component: Home,
}

export const routes = [
  {
    path: '/translation',
    title: 'Translation',
    component: Translation,
  },
  {
    path: '/interpreting',
    title: 'Interpreting',
    component: Interpreting,
  },
  {
    path: '/transcription',
    title: 'Transcription',
    component: Transcription,
  },
  {
    path: '/subtitling',
    title: 'Subtitling',
    component: Subtitling,
  },
  {
    path: '/editing',
    title: 'Editing and proofreading',
    component: Editing,
  },
  {
    path: '/contact',
    title: 'Contact',
    component: Contact,
  },
  {
    path: '/portfolio',
    title: 'Portfolio',
    component: Portfolio,
  },
]
